import * as angular from "angular";
import {IController} from "angular";
import './Users.scss';
import {EditUserDialogComponent} from "../dialog/new_user/edit.user.dialog.component";
import {BrandService} from "../../brand_service/service/BrandService";
import {BrandServiceName, ToastNotificationServiceName, UserServiceName} from "../../utils/names/serviceNames";
import {UserService} from "../../users_service/service/user.service";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {UserDto} from "../model/User";
import {Page} from "../../utils/models/Page";
import {LqbUserUpdateResultComponent} from "../dialog/lqb_update_result/lqb-user-update-result.component";
import {UserFilter, UserView} from "../model/UserFilter";
import {APPLICATION_ACCESS_LEVEL_TOGGLES} from "../model/AccessLevelToggle";
import {UserAccessRole} from "../model/UserAccessRole";
import {Principle} from "../../brand_service/model/Principle";
import {PrincipalUtil} from "../../utils/PrincipalUtil";


export class UsersController implements IController {

    public static instance = [
        '$mdDialog',
        'loggedInUser',
        BrandServiceName,
        UserServiceName,
        ToastNotificationServiceName,
        UsersController
    ];

    filter: UserFilter = {
        query: '',
        view: UserView.LIMITED_VIEW,
        userIds: [],
        branchesIds: [],
        showDeleted: false,
        showDisabled: true,
    };

    usersPage: Page<UserDto> = {number: 1, size: 10};
    showLoader = false;
    disablePullLqb = false;

    constructor(private $mdDialog: angular.material.IDialogService,
                private loggedInUser: Principle,
                private brandService: BrandService,
                private userService: UserService,
                private toastNotificationService: ToastNotificationService) {
        this.asychOperationStarted();
        this.getAllUsersPage()
            .then(() => {
                this.asychOperationFinished();
            });
    }

    getAllUsersPage = (): angular.IPromise<void> => {
        let usersPage = this.usersPage;
        return this.userService.getFilteredUsers(this.filter, usersPage.number - 1, usersPage.size)
            .then(resp => {
                if (resp.status === 200) {
                    let usersPage = resp.data;
                    usersPage.number += 1;
                    this.usersPage = usersPage;
                }
            })
    };

    getLoggedInUser = (): angular.IPromise<Principle> => {
        return PrincipalUtil.getPrinciple()
            .then(principle => this.loggedInUser = principle);
    };


    openNewUserDialog = ($event: MouseEvent) => {
        let user = UsersController.initializeNewUser();
        this.$mdDialog.show(EditUserDialogComponent.instance($event, user, this.loggedInUser));
    };

    pullLqbUsers = ($event: MouseEvent) => {
        this.asychOperationStarted();
        this.userService.getLqbUsers()
            .then(resp => {
                    this.asychOperationFinished();
                    if (resp.status == 200) {
                        this.$mdDialog.show(LqbUserUpdateResultComponent.instance($event, resp.data))
                            .then((resp) => {
                                this.toastNotificationService.generateErrorMessage("Successfully pulled lqb users!")
                            });
                    }
                }, (err) => {
                    this.asychOperationFinished();
                    this.toastNotificationService.generateErrorMessage("Failed to pull users!")
                }
            );
    };

    setEmployeeIds = (newValue: number[]) => {
        this.filter.userIds = newValue;
    };

    fetchUsers = (query: string) => {
        let filter = Object.assign({}, this.filter);
        filter.query = query;
        filter.userIds = [];
        filter.view = UserView.AUTOCOMPLETE;
        return this.userService
            .queryEmployee(filter)
            .then(resp => {
                if (resp.status === 200) {
                    return resp.data;
                } else {
                    this.toastNotificationService.generateErrorMessage('Failed to fetch users')
                }
            });
    };

    asychOperationStarted = () => {
        this.showLoader = true;
        this.disablePullLqb = true;
    };

    asychOperationFinished = () => {
        this.showLoader = false;
        this.disablePullLqb = false;
    };

    setSelectedBranchesIds = (selectedBranchesIds: string[]) => {
        this.filter.branchesIds = selectedBranchesIds;
    };


    static initializeNewUser() {
        return {
            isActive: false,
            isDeleted: false,
            isSubscribedToTheDailyEmails: true,
            applyWithMe: 'https://nflp.com/',
            accessLevel: UserAccessRole.INDIVIDUAL,
            featureAccessLevel: APPLICATION_ACCESS_LEVEL_TOGGLES()
        };
    }

}